const getters = {
  moduleName: state => {
    return state.module ? state.module.name : "";
  },
  moduleTitle: state => {
    return state.module ? state.module.title : "";
  },
  moduleIcon: state => {
    return state.module ? state.module.icon : "";
  },
  moduleEntity: state => {
    return state.module ? state.module.entity : "";
  },
  permittedModules: state => state.permittedModules,
  myProfile: state => {
    return state.myProfile;
  },
  myTimeOffBalance: state => {
    return state.myTimeOffBalance;
  },
  myTimeOff: state => {
    return state.myTimeOff;
  },
  teamTime: state => {
    return state.teamTime;
  },
  employeesUnder: state => {
    return state.employeesUnder;
  },
  myTasks: state => {
    return state.myTasks;
  },
  myTasksCount: state => {
    return state.myTasksCount;
  },
  myTask: state => {
    return state.myTask;
  },
  requestTrail: state => {
    return state.requestTrail;
  },
  userManagement: state => {
    return state.userManagement;
  },
  roles: state => {
    return state.roles;
  },
  rolesAssociation: state => {
    return state.rolesAssociation;
  },
  rolePermissions: state => {
    return state.rolePermissions;
  },
  timeOffRequestCreated: state => {
    return state.timeOffRequestCreated;
  },
  directDeposits: state => {
    return state.directDeposits;
  },
  payrollItems: state => {
    return state.payrollItems;
  },
  payrollItemDetails: state => {
    return state.payrollItemDetails;
  },
  payrollChecks: state => {
    return state.payrollChecks;
  },
  payrollCheckDetails: state => {
    return state.payrollCheckDetails;
  },
  payrollTask: state => {
    return state.payrollTask;
  },
  /**
   * Getter for payrollRegistered
   * @param state
   * @return {{code: string, message: string}}
   */
  payrollRegistered: state => {
    return state.payrollRegistered;
  },
  /**
   * Getter for next status list of task
   * @param state
   * @return {{id: number, value: string}[]}
   */
  nextStatusListTask: state => {
    return state.nextStatusListTask;
  },
  /**
   * Getter for association list
   * @param state
   * @return {{id: number, assosOf: string, assos: string, assosWith: string}[]}
   */
  associationList: state => {
    return state.associationList;
  },
  /**
   * Getter for cost centers
   * @param state
   * @return {{code: string, description: string, id: number, status: string}[]}
   */
  costCenters: state => {
    return state.costCenters;
  },
  /**
   * Getter for user assignments
   * @param state
   * @return {{code: string, description: string, id: number, status: string}[]}
   */
  userAssignments: state => {
    return state.userAssignments;
  },
  timeEntryApprovalRefId: state => {
    return state.timeEntryApprovalRefId;
  },
  payCycles: state => {
    return state.payCycles;
  },
  payCycleDetail: state => {
    return state.payCycleDetail;
  },
  taskPermission: state => {
    return state.taskPermission;
  },
  userGroups: state => {
    return state.userGroups;
  },
  assignmentHistory: state => {
    return state.assignmentHistory;
  },
  timeOffEntries: state => {
    return state.timeOffEntries;
  },
  transactionDetails: state => {
    return state.transactionDetails;
  },
  publishedW2: state => {
    return state.publishedW2;
  },
  attributes: state => {
    return state.attributes;
  },
  dependents: state => {
    return state.dependents;
  },
  requests: state => {
    return state.requests;
  }
};

export default getters;
